/* eslint-disable global-require */
import React, { useState } from "react";
import { Form } from "antd";
import { useTranslation } from "react-i18next";

// common
import {
  ProgramSelectorContainer,
  ProgramOption,
  ProgramInfoContainer,
  ProgramDescription,
  ProgramHintText,
} from "common/program_selector";
import { ModalLayout, MoreModalButtons } from "common/modal";
import { CheckboxGroup, CustomCheckbox } from "common/checkbox";
import PromoCode from "common/promo_code";

// styling
import { Program } from "types";
import { FormCard, CardTitle, LinkedText } from "./RegistrationStyle";
import {
  NameOnCard,
  CardElementsStyling,
  CustomCardElement,
} from "./PaymentFormStyle";
import TotalAmount from "./TotalAmount";
// types

const { ModalRow, ModalCol } = ModalLayout;
const { ButtonContainer, ModalButtonYellow } = MoreModalButtons;

type PaymentFormProps = {
  chosenProgram: Program;
  loading: boolean;
  onToggleProgramSel: () => void;
  programSelVisible: boolean;
};

const PaymentForm = ({
  chosenProgram,
  loading,
  onToggleProgramSel,
  programSelVisible,
}: PaymentFormProps) => {
  const { t } = useTranslation("registration");

  const [discount, setDiscount] = useState(0);

  return (
    <FormCard>
      <CardTitle>{t("COURSE DETAILS")}</CardTitle>
      {/** TODO: use query to get chosen programs */}
      <ProgramSelectorContainer value={chosenProgram.id}>
        <ProgramOption
          value={chosenProgram.id}
          checked
          onClick={() => onToggleProgramSel()}
        >
          <ProgramInfoContainer>
            <ProgramDescription style={{ display: "block" }}>
              <div
                style={{
                  whiteSpace: "normal",
                  textAlign: "left",
                  paddingRight: "10px",
                }}
              >
                {chosenProgram.name}
              </div>
              {!programSelVisible && (
                <ProgramHintText>
                  {t("Click to change program")}
                </ProgramHintText>
              )}
            </ProgramDescription>
          </ProgramInfoContainer>
        </ProgramOption>
      </ProgramSelectorContainer>

      <TotalAmount
        classPrice={chosenProgram.price}
        discountAmount={discount}
        currency={chosenProgram.currency}
      />
      <PromoCode
        classPrice={chosenProgram.price}
        setDiscount={setDiscount}
        currency={chosenProgram.currency}
      />

      <CardTitle>{t("PAYMENT METHOD")}</CardTitle>

      <Form.Item
        name="cardInfo"
        rules={[
          {
            required: true,
            message: t("Card info is required."),
          },
          () => ({
            validator(rule, value) {
              if (value && !value.complete) {
                return Promise.reject(new Error(t("Invalid card info.")));
              }
              return Promise.resolve();
            },
          }),
        ]}
      >
        <CustomCardElement options={CardElementsStyling} />
      </Form.Item>

      <ModalRow>
        <ModalCol xs={24}>
          <Form.Item
            name="cardholderName"
            rules={[
              {
                required: true,
                message: t("Card holder's name is required."),
              },
            ]}
          >
            <NameOnCard placeholder={t("Name on Card")} />
          </Form.Item>
        </ModalCol>
      </ModalRow>

      <CheckboxGroup>
        <Form.Item
          name="termsAndConditions"
          rules={[
            {
              // For checkbox, have to do this kind of validation.
              // Cannot simply use required:true like for input, will lead to inconsistency.
              validator: (_, value) =>
                value
                  ? Promise.resolve()
                  : Promise.reject(
                      new Error(
                        t(
                          "Agreement to LTL's Terms and Conditions is required."
                        )
                      )
                    ),
            },
          ]}
          valuePropName="checked"
        >
          <CustomCheckbox name="agreedPrivacyPolicy">
            {t("I agree to the")}
            <a
              href={t("TERM_CONDITION_URL")}
              target="_blank"
              rel="noopener noreferrer"
            >
              <LinkedText role="button" className="linked-text">
                {" "}
                {t("Terms and Conditions")}{" "}
              </LinkedText>
            </a>
          </CustomCheckbox>
        </Form.Item>
      </CheckboxGroup>

      <ModalRow>
        <ButtonContainer xs={24} sm={24} md={17}>
          <Form.Item>
            <ModalButtonYellow
              type="primary"
              htmlType="submit"
              loading={loading}
            >
              {t("CONFIRM PAYMENT")}
            </ModalButtonYellow>
          </Form.Item>
        </ButtonContainer>
        <ModalCol xs={0} sm={0} md={7} />
      </ModalRow>
      <ModalRow>
        <ButtonContainer xs={24} sm={24} md={17}>
          <a
            href="https://stripe.com/customers"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={require("assets/stripe.png")} alt="Stripe" />
          </a>
        </ButtonContainer>
        <ModalCol xs={0} sm={0} md={7} />
      </ModalRow>
    </FormCard>
  );
};

export default PaymentForm;
